import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => {
	return {
		root: {
			width: "24px",
			height: "24px",
			border: `1px solid ${theme.palette.colors.disabled}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexShrink: 0,
			"& span": {
				fontSize: "14px",
				color: theme.palette.colors.white,
				display: "none",
			},
		},
		active: {
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
			backgroundColor: theme.palette.colors.purplishBlue,
			"& span": {
				display: "block",
			},
		},
		error: {
			border: `1px solid ${theme.palette.colors.coralPink}`,
		},
	};
};

class CounterButton extends React.Component {
	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.active]: this.props.active,
					[classes.error]: this.props.error,
				})}
			>
				<span className="icon24 icon-check" />
			</div>
		);
	}
}

export default withStyles(styles)(CounterButton);
